var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4"},[(_vm.pageTitle)?_c('h1',{staticClass:"mb-6 mt-4"},[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")]):_vm._e(),(_vm.mediaUrl)?_c('v-img',{staticClass:"mb-4",attrs:{"src":_vm.mediaUrl,"aspect-ratio":"1.7"}}):_vm._e(),(_vm.pageContent)?_c('vue-markdown',{attrs:{"source":_vm.pageContent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }